// Formata valor monetário em BRL
export const formatCurrency = (value) => {
  if (value === null || value === undefined) return '—';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};

// Formata data
export const formatDate = (dateString) => {
  if (!dateString) return '—';
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(dateString));
};

// Formata data e hora
export const formatDateTime = (dateString) => {
  if (!dateString) return '—';
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(dateString));
};

// Retorna classes Tailwind para o badge de status do produto
export const getStatusBadgeClass = (status) => {
  const map = {
    'Disponível': 'badge bg-emerald-100 text-emerald-800',
    'Reservado':  'badge bg-amber-100 text-amber-800',
    'Vendido':    'badge bg-gray-100 text-gray-500',
  };
  return map[status] || 'badge bg-gray-100 text-gray-500';
};

// Retorna classes Tailwind para o badge de estado físico
export const getEstadoBadgeClass = (estado) => {
  const map = {
    'Novo':       'badge bg-gray-900 text-white',
    'Usado':      'badge bg-gray-100 text-gray-700',
    'Danificado': 'badge bg-red-100 text-red-700',
  };
  return map[estado] || 'badge bg-gray-100 text-gray-600';
};
